import { ReactElement, useState } from 'react';
import { Component as CaretDownIcon } from 'icons/icon-ui--caret-outline.svg';
import { Component as CaretUpIcon } from 'icons/icon-ui--caret-up-outline.svg';
import styles from './LimitedTimeOffering.module.scss';

type Ingredient = {
  id: number;
  text: string;
};

type Props = {
  ingredients?: Ingredient[];
};

function RecipeIngredients({
  ingredients,
}: Props): ReactElement {
  const [showIngredients, setShowIngredients] = useState(true);
  const toggleShowIngredients = () => setShowIngredients((prev) => !prev);
  const IngredientsIcon = showIngredients ? CaretUpIcon : CaretDownIcon;
  return (
    <>
      {ingredients && (
        <div className={styles.faq_section}>
          <div
            role="button"
            tabIndex={0}
            onClick={toggleShowIngredients}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleShowIngredients();
              }
            }}
          >
            <div className={styles.dropdown}>
              <h3>Ingredients</h3>
              <IngredientsIcon width={23} />
            </div>
          </div>
          <hr />
          {showIngredients && (
            <ul className={styles.ingredients}>
              {ingredients.map((ingredient, index) => (
                <li key={index}>{ingredient}</li>
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
}

export default RecipeIngredients;
